import 'bootstrap/dist/css/bootstrap.css';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

import RootLayout from './pages/Root.js';

import Home from './pages/Home.js';
import Privacy from './pages/Privacy.js';
import Terms from './pages/Terms.js';
import './App.css';


const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />, 
    children: [
      { path: '/', element: <Home /> },
      { path: '/privacy', element: <Privacy /> },
      { path: '/terms', element: <Terms /> },
    ]
  },
]);

function App() {
  return (
    <>      
      <RouterProvider router={router} />

    </>
  );
}

export default App;
